module.exports = __webpack_public_path__ + "static/media/compare-not-match.fc248f0e.svg";